Ext.ns('mx.data');

mx.data.Region = mx.data.Record.create([
    {
        name: 'id',
        type: 'string',
    },
    {
        name: 'name',
        type: 'string',
    },
    {
        name: 'title',
        type: 'string',
    },
    {
        name: 'defaultAocBorders',
        type: 'string',
    },
    {
        name: 'map_id_and_url',
        type: 'string',
    },
    {
        name: 'map_key',
        type: 'string',
    },
    {
        name: 'map_type',
        type: 'string',
    },
    {
        name: 'centerLongitude',
        type: 'float',
    },
    {
        name: 'centerLatitude',
        type: 'float',
    },
    {
        name: 'client_name',
        type: 'string',
    },
]);

new mx.data.Store({
    storeId: 'regions',
    record: mx.data.Region,
    url: MXAT.API('regions/'),
    customReader: mx.data.JsonReaderTranslator,
    customReaderParams: {dictionaryPrefix: 'mx.app.core.mapTitles'},
});
